var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-comment-renderer"},[(_vm.comment && !_vm.editable)?_c('article',{domProps:{"innerHTML":_vm._s(_vm.comment)}}):_vm._e(),(_vm.editable)?_c('Editor',{attrs:{"note":_vm.note}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }